import { QueryState } from "src/app/core/models/query.model";
import { createTokenQueryServiceInstance } from "src/app/core/services/query-sentrynel.service";
import { SignalStoreConfig } from "src/app/shared/functions/store.functions";

export const WSZ_ENDPOINT = 'wsz';
export const WSZ_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(WSZ_ENDPOINT);


export const wszStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}


export const WSZ_DATATABLE_COLUMNS:any[] = [
  {
    name: 'id',
    label: 'Id',
    field: 'id',
    primaryKey: true,
    type:'text'
  },
  {
    name: 'nome',
    label: 'Nome',
    field: 'nome',
    type: 'text'

  },
  {
    name: 'dateOfCreation',
    label: 'Data creazione',
    field: 'dateOfCreation',
    type: 'text'

  },
  {
    name: 'dateOfLastRevision',
    label: 'Data ultima revisione',
    field: 'dateOfLastRevision',
    type: 'text'
  },
  {
    name: 'dateOfPublication',
    label: 'Data pubblicazione',
    field: 'dateOfPublication',
    type: 'text'
  }
]

export const WSZ_DATATABLE_VISIBLE_COLUMNS = [
  'select',
  'nome',
  'dateOfCreation',
  'dateOfLastRevision',
  'dateOfPublication',
  'azioni'
]